import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { ImportsListPage } from '@/features/imports';
import { zSearchText } from '@/shared/lib/search';

/**
 * `upload=…` opens the upload dialog with that layout chosen: `employer_list` (Employers → Import), `customer_list`
 * (Customers → Import), `bank_employer_list` (Employers → Import bank list; `bank` preselects the bank) or `auto`
 * (Deals → Import tracker; DIB/SIB trackers are detected from the file).
 */
const searchSchema = z.object({ upload: z.enum(['auto', 'employer_list', 'customer_list', 'bank_employer_list']).optional().catch(undefined), bank: zSearchText() });

export const Route = createFileRoute('/_app/admin/imports/')({
  staticData: { crumb: 'admin:nav.imports' },
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'import.run', 'Imports'),
  component: function Imports() {
    const navigate = Route.useNavigate();
    const { upload, bank } = Route.useSearch();
    return <ImportsListPage upload={upload} bank={bank} onUploadClose={() => void navigate({ search: {}, replace: true })} onOpen={(importId) => void navigate({ to: '/admin/imports/$importId', params: { importId } })} />;
  },
});
